const FORMATO_ISO = /^\d{4}-\d{2}-\d{2}$/

const decodificarBase64 = (valor: string): string | null => {
  try {
    return decodeURIComponent(escape(window.atob(valor)))
  } catch (error) {
    try {
      return window.atob(valor)
    } catch (otro) {
      return null
    }
  }
}

const leerJson = (valor: any): any => {
  if (!valor) return null
  if (typeof valor === 'object') return valor
  if (typeof valor !== 'string') return null

  try {
    return JSON.parse(valor)
  } catch (error) {
    const texto = decodificarBase64(valor)
    if (!texto) return null
    try {
      return JSON.parse(texto)
    } catch (otro) {
      return null
    }
  }
}

const leerCargaDeToken = (token: any): any => {
  if (typeof token !== 'string') return null
  const partes = token.split('.')
  if (partes.length < 2) return null

  const normalizado = partes[1].replace(/-/g, '+').replace(/_/g, '/')
  const texto = decodificarBase64(normalizado)
  if (!texto) return null

  try {
    return JSON.parse(texto)
  } catch (error) {
    return null
  }
}

const fechaValida = (valor: any): string | null => {
  const texto = `${valor ?? ''}`.trim()
  return FORMATO_ISO.test(texto) ? texto : null
}

export const fechaGeneracionDelDte = (respuestaEmision: any): string | null => {
  if (!respuestaEmision) return null

  const documento = leerJson(respuestaEmision.JsonFacturaFile)
  const desdeArchivo = fechaValida(documento?.identificacion?.fecEmi)
  if (desdeArchivo) return desdeArchivo

  const carga = leerCargaDeToken(respuestaEmision.JsonFactura)
  const identificacion = leerJson(carga?.identificacion) ?? carga?.identificacion
  const desdeToken = fechaValida(identificacion?.fecEmi)
  if (desdeToken) return desdeToken

  return fechaValida(respuestaEmision.fecEmi)
}
